<template>
  <div class="pjmain">
    <div class="content" v-cloak>


        <van-cell-group>
          <van-field v-model="xzlist.content" label="处理结果" placeholder="处理结果" input-align="right" required type="textarea"></van-field>

				<div class="shangchuan">
				    <div class="sctitle">
				        <!-- <span class="red">*</span> -->
				        <span class="" >图片</span>
				    </div>
				    <van-uploader :after-read="imgPreview" multiple  v-model="attachs" style="width:85%"></van-uploader>
				</div>
        </van-cell-group>
        <div class="bt md20">
          <button @click="add()" class="btn">提交</button>
        </div>
      
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage, ImagePreview } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
export default {
  data() {
    return {
      isPingjia: false,
      levels: [
        { id: "0", value: "", text: "满意", title: "" },
        { id: "1", value: "", text: "不满意", title: "" },
      ],
      xzlist: {
        level: "",
        content: "",
      },
      tsxq: {},
      bxxq: {},
      type: 1,
      attachs:[],
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var type = this.$route.query.type || 1;
    this.type = type;
    this.isPingjia = this.$route.query.pj;
    if (type == 1) {
      this.$axios.get("/api/v1/complaint/" + id).then((res) => {
        this.tsxq = res;
      });
    } else {
      this.$axios.get("/api/v1/repair/" + id).then((res) => {
        this.bxxq = res;
      });
    }
  },
  methods: {
    changeType(e) {
      console.log(e);
    },
        imgPreview(file) {
            let arr = []
            let self = this
            let Orientation
            if(file.length == undefined){
               var fobj = file
               arr.push(fobj)
            }else{
               file.forEach(item=>{
                arr.push(item)
               })
            }
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return
            arr.map(item=>{
                if (/^image/.test(item.file.type)) {
                    // 创建一个reader
                    let reader = new FileReader()
                    // 将图片2将转成 base64 格式
                    let name = item.file.name
                    reader.readAsDataURL(item.file)
                    // 读取成功后的回调
                    var nf = null
                    reader.onloadend = function() {
                        let result = this.result
                        let img = new Image()
                        img.src = result
                        //判断图片是否大于200K,是就直接上传，反之压缩图片
                        if (this.result.length <= 200 * 1024) {
                            // 上传图片
                            console.log('正好')
                            item.file = self.dataURLtoFile(this.result,name)
                            self.afterRead(item)
                        } else {
                            console.log('大图')
                            img.onload = function() {
                                let data = self.compress(img, Orientation)
                                item.file  = self.dataURLtoFile(data,name)
                                self.afterRead(item)
                            }
                        }
                    }
                }
            })
            this.$emit('childimglist',self.xczk)
        },
        //将base64转换为文件
        dataURLtoFile(dataurl, filename) { 
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        // 压缩图片
        compress(img, Orientation) {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            //瓦片canvas
            let tCanvas = document.createElement('canvas')
            let tctx = tCanvas.getContext('2d')
            // let initSize = img.src.length;
            let width = img.width
            let height = img.height
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio
            if ((ratio = (width * height) / 4000000) > 1) {
                // console.log("大于400万像素");
                ratio = Math.sqrt(ratio)
                width /= ratio
                height /= ratio
            } else {
                ratio = 1
            }
            canvas.width = width
            canvas.height = height
            //    铺底色
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            //如果图片像素大于100万则使用瓦片绘制
            let count
            if ((count = (width * height) / 1000000) > 1) {
                // console.log("超过100W像素");
                count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
                //      计算每块瓦片的宽和高
                let nw = ~~(width / count)
                let nh = ~~(height / count)
                tCanvas.width = nw
                tCanvas.height = nh
                for (let i = 0; i < count; i++) {
                for (let j = 0; j < count; j++) {
                    tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
                    ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
                }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height)
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != '' && Orientation != 1) {
                switch (Orientation) {
                case 6: //需要顺时针（向左）90度旋转
                    this.rotateImg(img, 'left', canvas)
                    break
                case 8: //需要逆时针（向右）90度旋转
                    this.rotateImg(img, 'right', canvas)
                    break
                case 3: //需要180度旋转
                    this.rotateImg(img, 'right', canvas) //转两次
                    this.rotateImg(img, 'right', canvas)
                    break
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.15)
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata
        },
        // 旋转图片
        rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            const min_step = 0
            const max_step = 3
            if (img == null) return
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            let height = img.height
            let width = img.width
            let step = 2
            if (step == null) {
                step = min_step
            }
            if (direction == 'right') {
                step++
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step)
            } else {
                step--
                step < min_step && (step = max_step)
            }
            //旋转角度以弧度值为参数
            let degree = (step * 90 * Math.PI) / 180
            let ctx = canvas.getContext('2d')
            switch (step) {
                case 0:
                canvas.width = width
                canvas.height = height
                ctx.drawImage(img, 0, 0)
                break
                case 1:
                canvas.width = height
                canvas.height = width
                ctx.rotate(degree)
                ctx.drawImage(img, 0, -height)
                break
                case 2:
                canvas.width = width
                canvas.height = height
                ctx.rotate(degree)
                ctx.drawImage(img, -width, -height)
                break
                case 3:
                canvas.width = height
                canvas.height = width
                ctx.rotate(degree)
                ctx.drawImage(img, -width, 0)
                break
            }
        },
        //上传照片的接口
        afterRead(file){
            var that = this
            let content = file.file;
            let data = new FormData();
            data.append('file',content);
            data.append('moduleCode','tsbx');
            data.append('moduleName','投诉报修');
            file.status= 'uploading',
            file.message= '上传中...'
            let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
			   };
            this.$axios.post('/api/v1/common/upload',data, config)
            .then(result=>{
                if(result.id){
                    file.srcs = result.webUrl
                    file.status = 'done'
                    file.message =''
                    file.id = result.id
                }else{
                    that.$toast.fail('图片上传失败，请重试！');
                    file.status='failed'
                    file.message= '上传失败'
                }
            })
        },
    add() {
      var vm=this
      if (this.xzlist.content == "") {
        this.$dialog({ message: "处理结果未填" });
        return;
      }
     var attachs=vm.attachs.map(item=>{
      return {
        id:item.id
      }
     })
      var jsonData = {

        attachs: attachs,
        complaint:{
        id:this.$route.query.id
      }

      
      };

      var postUrl = "";
        postUrl = "/api/v1/complaint/handler/wgsq"
      this.$axios.post(postUrl, jsonData).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          // this.$router.go(-1);
          this.$router.push({ path: "/tsbx/bjlist", query: {tp:this.tp} });
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  // border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      font-size: 14px;
      color: #999999;
      margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
</style>